import type { Route } from 'next';

/**
 * Internal path for static link data ("/info/about", "/catalog?direction=body").
 * Link and the link components infer the typed route from it; a plain `Route` needs a literal.
 */
export type AppHref = `/${string}`;

/** A same-origin path from runtime data (query parameter, pathname): one leading slash, no scheme. */
export function isAppPath(value: string | null | undefined): value is Route {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');
}
